import RecentlyViewedCarousel from "../RecentlyViewedCarousel";

const RecentlyViewedMenuWidget = ({ items, onSelect }) => (
  <RecentlyViewedCarousel
    items={items}
    onSelect={onSelect}
    variant="menu"
    title="Recently viewed"
  />
);

export default RecentlyViewedMenuWidget;
